// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Initialize Supabase client with migration support
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Supabase client configuration validated
const useAwsBackend = import.meta.env.VITE_USE_AWS_BACKEND === 'true';
const isDevMode = import.meta.env.VITE_DEV_MODE === 'true';
const bypassAuth = import.meta.env.VITE_BYPASS_AUTH === 'true';

// During AWS migration, Supabase may not be configured
if (!useAwsBackend && (!supabaseUrl || !supabaseKey)) {
  throw new Error('Missing Supabase environment variables');
}

// Provide fallback values during AWS migration
const fallbackUrl = supabaseUrl || 'https://placeholder.supabase.co';
const fallbackKey = supabaseKey || 'placeholder-key';

// Validate URL format only if we're actually using Supabase and have a valid URL
if (!useAwsBackend && supabaseUrl && supabaseUrl !== 'https://placeholder.supabase.co') {
  try {
    new URL(supabaseUrl);
  } catch (error) {
    console.warn('[SUPABASE] Invalid Supabase URL format, using AWS backend:', error);
    // Don't throw error during AWS migration - just log warning
  }
}

// Dev mode configuration - disable problematic features
const devModeConfig = isDevMode && bypassAuth ? {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    storage: undefined,
  },
  realtime: {
    params: {
      eventsPerSecond: 0, // Disable realtime in dev mode
    },
  },
  global: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  },
  db: {
    schema: 'public',
  },
} : {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  realtime: {
    params: {
      eventsPerSecond: 0, // Disable realtime to prevent WebSocket errors
    },
  },
  global: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Encoding': 'gzip, deflate, br',
      'Accept-Language': 'en-US,en;q=0.9',
    },
  },
  db: {
    schema: 'public',
  },
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(fallbackUrl, fallbackKey, devModeConfig);
